export default {
  computed: {
    inputListeners() {
      const vm = this;
      return Object.assign({},
        // We add all the listeners from the parent
        this.$listeners,
        {
          input: (event) => {
            vm.inputVal = event.target.value;
            vm.$emit('input', event.target.value);
          },
        });
    },
  },
};
